import React from "react";
import { useNavigate } from "react-router-dom";

const BackPath = ({ children, path }) => {
  const navigate = useNavigate();
  return (
    <span
      className="cursor-pointer lg:text-xl md:text-xl sm:text-md max-sm:text-md  font-semibold text-white"
      onClick={() => navigate(path)}
    >
      {children}
    </span>
  );
};

export default BackPath;
